import React from 'react';
import { useRouteMatch } from 'react-router';

import { useCourse } from './useCourse';
import { DynamicPageTitle } from '../../components';
import { CourseComponent } from './CourseComponent';

const CoursePage: React.FC = () => {
  const { params } = useRouteMatch<{ id: string }>();
  const { course, enrollment, loading, refreshEnrollment } = useCourse(
    params?.id
  );

  if (!course || !enrollment || loading) {
    return <DynamicPageTitle>Course</DynamicPageTitle>;
  }

  return (
    <>
      <DynamicPageTitle>Course</DynamicPageTitle>
      <CourseComponent
        course={course}
        enrollment={enrollment}
        onRefresh={refreshEnrollment}
      />
    </>
  );
};

export default CoursePage;
